import apiClient from 'api/apiConfig';
import { DashboardFilterTypes } from './dashboardFilterTypes';
import { ServerDashboardDashboard } from './dashboardType';

const DASHBOARD_URL = 'csb/jobs/hierarchical';

export const fetchDashboard = async (
  filters: DashboardFilterTypes
): Promise<ServerDashboardDashboard> => {
  const response = await apiClient.post<ServerDashboardDashboard>(
    DASHBOARD_URL,
    filters,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
